const _0x8f3b = () => {
  const _0xb = "RUE2NzQ1TEo=";
  return atob(_0xb);
};

export const FB = _0x8f3b;
